<template>
  <div :class="['ResetPassword-Container', isMobile]">
    <h1 class="title">{{ $t('auth.forgot_password.sub_welcome') }}</h1>

    <span v-if="success">{{ $t('auth.forgot_password.success') }}</span>

    <form class="login_form" @submit.prevent="resetPassword">
      <vv-form-text-input
        label="username"
        id="username"
        v-model="username"
        :validate="'required|email'"
      />

      <validate-form-button
        @click="resetPassword"
        :class="['ValidateFormButton-Bis', isMobile]"
        :label="'forms.resetPasswordCta'"
        :isLoading="isLoading"
      />
    </form>
  </div>
</template>

<script>
import { RESET_PASSWORD } from '@/store/modules/user/types'
import ValidateFormButton from '@/components/common/forms/vinovibes/ValidateFormButton'
import VvFormTextInput from '@/components/common/forms/vinovibes/VvFormTextInput'
import { SNACKBAR_MESSAGE } from '@/helpers/eventBus'

export default {
  name: 'ResetPassword',
  components: {
    VvFormTextInput,
    ValidateFormButton
  },
  data: () => ({
    username: '',
    isLoading: false,
    success: false
  }),
  computed: {
    isMobile() {
      return this.$mq == 'desktop' ? '' : 'container-mobile'
    }
  },
  methods: {
    async resetPassword() {
      this.$validator.validateAll().then(async result => {
        if (!result) {
          return
        }

        this.isLoading = true

        const [error, response] = await this.$store.dispatch(RESET_PASSWORD, this.username)

        if (error || response.data.error) {
          if (error && error.code) {
            this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.' + error.code)})
          } else {
            if (response.data.code) {
              this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.' + response.data.code)})
            } else {
              this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.custom/internal-error')})
            }
          }

          this.isLoading = false
        } else {
          this.success = true
          this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('success.forgotPasswordEmailReceived')})
        }

        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/responsive.scss';

.ResetPassword-Container {
  display: flex;
  flex-direction: column;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  align-items: center;
  position: relative;
  left: -30px;
  padding-bottom: 100px;

  @include for-size(phone-only) {
    width: 80%;
  }

  &.container-mobile {
    left: 0;
  }

  .title {
    font-size: 2rem;
    color: $primary;
    font-weight: 700;
    margin-bottom: 0;
    letter-spacing: -2px;
    text-align: center;

    @include for-size(phone-only) {
      font-size: 2rem;
    }
  }
}

.FormText {
  height: 32px;
  border-radius: 5px;
  background-color: #f6f6f6;
  display: block;
  padding-bottom: 8px;
  width: 70%;
  margin-bottom: 14px;
}

form {
  background-color: $primary-alt;
  width: 60%;
  padding: 60px 50px 60px 50px;
  border-radius: 30px;

  @include for-size(phone-only) {
    width: 80%;
    padding: 20px 10px 20px 10px;

    .ValidateFormButton-Bis button {
      font-size: 12px !important;
    }
  }
}
</style>
